/* eslint-disable max-len */
import React from "react";
import Image from "@sparefoot/react-commons/Image";
import { Link } from "components/core/Typography";
import SubHeading from "./SubHeading";
import Description from "./Description";
import { BLOG_POSTS_DATA } from "../ContentData/HelpPageData";

function BlogPosts() {
	return (
		<div className="blog-posts-container">
			{BLOG_POSTS_DATA.map((blog) => (
				<div className="blog-post">
					<Image
						src={blog.image}
						alt={blog.imageAlt}
						weight="404"
						height="266"	
						lazy					
					/>
					<SubHeading title={blog.title} />
					<Description desc={blog.desc} />
					from{" "}
					<Link
						weight="bold"
						color="blue"
						href={blog.link}
						className="no-underline"
					>
						Storage Talk
					</Link>
				</div>
			))}
		</div>
	);
}

export default BlogPosts;
